import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/pages/Homepage'
import ErrorPage from '@/components/pages/ErrorPage'
import Page from '@/components/pages/Page'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Homepage',
            component: Page
        },
        {
            path: '/403',
            name: '403',
            component: ErrorPage
        },
        {
            path: '/404',
            name: '404',
            component: ErrorPage
        },
        {
            path: '*',
            name: 'GenericPage',
            component: Page
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.path == from.path && to.query.page == from.query.page && to.query.tags == from.query.tags) {
            return
        }

        return { x: 0, y: 0 };
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js